<template>
  <v-container fluid grid-list-md>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row wrap>
              <v-col cols="12" md="4">
                <date-time-view
                v-model="dateStart"
                label="Start Date"
                ></date-time-view>
              </v-col>
              <v-col cols="12" md="4">
                <date-time-view
                v-model="dateEnd"
                label="End Date"
                ></date-time-view>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn @click="resetDate()">Today</v-btn>
                <v-btn @click="resetDate()">Today</v-btn>
                <v-btn @click="resetDate()">Today</v-btn>
              </v-col>
            </v-row>
            <v-row wrap>

              <v-col cols="12" style="padding-top: 16px;">
                <span class="title">Report Name: {{ item.name }}</span>
                <div class="subheading" v-if="item.type==='reportTypeNotSeen'">This report shows all registered Assets that were <b>not</b> seen in the
                  specified zones during the specified time frame.
                </div>
                <div class="subheading" v-else-if="item.type==='reportTypeSeen'">This report shows all registered Assets that were seen in the
                  specified zones during the specified time frame.
                </div>
              </v-col>
              <v-col cols="12" class="subheading">
                <b>Zones:</b> {{ zoneNames }}
              </v-col>
              <v-col cols="12">
              <v-col cols="12" class="subheading">
                <v-btn :href="downloadUrl" color="success" style="width: 100%;" download>Download Report (.XLSX)</v-btn>
              </v-col>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import DateTimeView from '@/components/DateTimeView'
import { ENDPOINT } from '@/shared/constants'
import { LookupMixin } from '@/shared/mixins'

export default {
  components: {
    DateTimeView
  },

  mixins: [LookupMixin],

  data () {
    return {
      dateStart: moment().startOf('day').format(),
      dateEnd: moment().endOf('day').format(),
      item: {
        zones: []
      },
      zones: []
    }
  },

  created () {
    ApiRequests.getZones(this.selectedSite._id).then(r => {
      this.zones = r.data
      this.getData()
    })
  },

  watch: {
    '$route.params.id': function () {
      this.getData()
    }
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ]),

    downloadUrl: function () {
      var params = {
        after: this.dateStart,
        before: this.dateEnd
      }

      var url = ENDPOINT + 'reports/' + this.$route.params.id + '?' + new URLSearchParams(params).toString()
      return url
    },

    zoneNames: function () {
      return this.item.zones.map(e => this.getZoneName(e)).join(', ')
    }
  },

  methods: {
    getData: function () {
      ApiRequests.reportConfigGet(this.$route.params.id).then(r => {
        this.item = r.data
      })
    },

    resetDate: function () {
      this.dateStart = moment().startOf('day')
      this.dateEnd = moment().endOf('day')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ReportEdit.vue